export default "__VITE_ASSET__od7Ic3Xm__"